
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/AwardWinning",
      function () {
        return require("private-next-pages/article/AwardWinning.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/AwardWinning"])
      });
    }
  